import React from 'react';

type Props = {
  width: string
}

export const MapSvg = (props: Props): React.ReactElement => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={props.width} viewBox="0 0 98.039 80.568">
    <g id="Group_9" data-name="Group 9" transform="translate(-107 -768.302)">
      <path id="map-regular"
        d="M58.994,32.382a2.514,2.514,0,0,1,1.085,2.065V69.493a2.5,2.5,0,0,1-1.617,2.336L40.939,78.505a2.447,2.447,0,0,1-1.679.031L20.078,72.153,3.39,78.515A2.5,2.5,0,0,1,0,76.169V41.123a2.481,2.481,0,0,1,1.617-2.336L19.14,32.111a2.447,2.447,0,0,1,1.679-.031L40,38.463,56.689,32.1A2.508,2.508,0,0,1,59,32.382ZM5.007,42.844v29.7l12.516-4.767v-29.7ZM37.549,72.7V42.927L22.53,37.92V67.689Zm5.007-.156,12.516-4.767v-29.7L42.556,42.844Z"
        transform="translate(144.96 770.192)" fill="#1e3050"/>
      <path id="map-regular-2" data-name="map-regular"
        d="M58.994,32.382a2.514,2.514,0,0,1,1.085,2.065V69.493a2.5,2.5,0,0,1-1.617,2.336L40.939,78.505a2.447,2.447,0,0,1-1.679.031L20.078,72.153,3.39,78.515A2.5,2.5,0,0,1,0,76.169V41.123a2.481,2.481,0,0,1,1.617-2.336L19.14,32.111a2.447,2.447,0,0,1,1.679-.031L40,38.463,56.689,32.1A2.508,2.508,0,0,1,59,32.382ZM5.007,42.844v29.7l12.516-4.767v-29.7ZM37.549,72.7V42.927L22.53,37.92V67.689Zm5.007-.156,12.516-4.767v-29.7L42.556,42.844Z"
        transform="translate(107 770.192)" fill="#1e3050"/>
      <path id="location-dot-solid"
        d="M15.133,35.022c3.6-4.5,11.807-15.42,11.807-21.552A13.47,13.47,0,0,0,0,13.47C0,19.6,8.208,30.518,11.807,35.022a2.12,2.12,0,0,0,3.325,0ZM13.47,8.98a4.49,4.49,0,1,1-4.49,4.49A4.49,4.49,0,0,1,13.47,8.98Z"
        transform="translate(134 768.302)" fill="#ef7f1a"/>
    </g>
  </svg>

}
